import * as React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {
  galleryStrip,
  galleryItem,
  galleryItemActive,
  galleryThumb,
  galleryLabel,
} from "../styles/portfolio-detail.module.scss";

const slugify = (text) =>
  text
    ?.toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "") || "";

let persistedGalleryScrollLeft = 0;

const PortfolioDetailGallery = ({ activeStrapiId }) => {
  const stripRef = React.useRef(null);
  const data = useStaticQuery(graphql`
    query PortfolioDetailGallery {
      allStrapiPortfolio {
        nodes {
          Title
          strapi_id
          MainAsset {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 264
                  height: 330
                  quality: 90
                  placeholder: NONE
                )
              }
            }
          }
        }
      }
    }
  `);

  const portfolios = data?.allStrapiPortfolio?.nodes || [];

  React.useLayoutEffect(() => {
    const el = stripRef.current;
    if (!el) return;

    if (persistedGalleryScrollLeft > 0) {
      el.scrollLeft = persistedGalleryScrollLeft;
      return;
    }

    el.scrollLeft = el.scrollWidth - el.clientWidth;
  }, [activeStrapiId]);

  const onStripScroll = React.useCallback(() => {
    if (stripRef.current) {
      persistedGalleryScrollLeft = stripRef.current.scrollLeft;
    }
  }, []);

  return (
    <div
      ref={stripRef}
      className={galleryStrip}
      data-portfolio-detail-gallery
      onScroll={onStripScroll}
    >
      {portfolios.map((item) => {
        const thumb = getImage(item?.MainAsset?.localFile);
        const slug = slugify(item.Title);
        const isActive = item.strapi_id === activeStrapiId;

        return (
          <Link
            key={item.strapi_id}
            to={`/portfolio/${slug}`}
            className={`${galleryItem} ${isActive ? galleryItemActive : ""}`}
          >
            <span className={galleryLabel}>
              {item.Title}
              <span> ↗</span>
            </span>
            {thumb && (
              <GatsbyImage
                image={thumb}
                alt={item.Title || "Portfolio"}
                className={galleryThumb}
              />
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default PortfolioDetailGallery;
